import React from 'react'
import StoreTranferList from './StoreTranferList'

const StoreReturnTransSubLoc = ({ history }) => {
  return (
    <StoreTranferList history={history} forReturn={true} />
  )
}

export default StoreReturnTransSubLoc